import { Controller } from '@hotwired/stimulus';
import { useClickOutside } from 'stimulus-use';
import { lockBodyScroll, unlockBodyScroll } from '../bodyScrollLock';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
  static targets = ['content', 'close', 'open'];

  static values = {
    open: Boolean,
  };

  connect() {
    useClickOutside(this, { element: this.contentTarget })
  }

  clickOutside() {
    this.close();
  }

  openValueChanged() {
    document.body.classList.toggle('has-overlay', this.openValue);
    if (this.hasOpenTarget) {
      this.openTarget.setAttribute('aria-expanded', this.openValue);
    }
    if (this.hasCloseTarget) {
      this.closeTarget.setAttribute('aria-expanded', this.openValue);
    }
  }

  open() {
    this.openValue = true;
    lockBodyScroll(this.contentTarget);
  }

  close() {
    this.openValue = false;
    unlockBodyScroll(this.contentTarget);
  }
}